import { z } from 'zod';
import { JSON_RPC_VERSION } from '../constants/json-rpc.js';
export const jsonRpcVersionSchema = z.literal(JSON_RPC_VERSION);
export const jsonRpcIdSchema = z.union([z.string(), z.number(), z.null()]);
export const jsonRpcErrorObjectSchema = z.object({
    code: z.number().int(),
    message: z.string().min(1),
    data: z.unknown().optional(),
}).strict();
export const jsonRpcRequestSchema = z.object({
    jsonrpc: jsonRpcVersionSchema,
    method: z.string().min(1),
    params: z.union([
        z.array(z.unknown()),
        z.record(z.string(), z.unknown()),
    ]).optional(),
    id: jsonRpcIdSchema.optional(),
}).strict();
export const dataEnvelopeSchema = (dataSchema) => z.object({
    data: dataSchema,
}).strict();
export const jsonRpcSuccessEnvelopeSchema = (resultSchema) => z.object({
    jsonrpc: jsonRpcVersionSchema,
    result: resultSchema,
    id: jsonRpcIdSchema,
}).strict();
/** Envelope produced by `rpcProxy` — wraps an upstream JSON-RPC result inside `data`. */
export const rpcProxyResultEnvelopeSchema = (resultSchema) => jsonRpcSuccessEnvelopeSchema(dataEnvelopeSchema(z.object({
    jsonrpc: jsonRpcVersionSchema,
    id: jsonRpcIdSchema,
    result: resultSchema,
}).strict()));
export const jsonRpcErrorEnvelopeSchema = z.object({
    jsonrpc: jsonRpcVersionSchema,
    error: jsonRpcErrorObjectSchema,
    id: jsonRpcIdSchema,
}).strict();
